<div class="modal-header">
  <h5 class="modal-title flex align-items-center">
    <i
      class="fas fa-map-marker-alt me-2"
      style="color: #00549d; font-size: 1.5rem"
    ></i>
    <span style="font-size: 16px; color: #0063b9"
      >Elige donde recibir tus compras</span
    >
  </h5>
  <button type="button" class="btn" (click)="ModalRef.hide()">
    <i class="fas fa-times-circle" style="color: #00549d; font-size: 18px"></i>
  </button>
</div>

<div class="modal-body">
  <div class="list-group overflow-auto" style="max-height: 450px">
    @for (item of direcciones; track $index) {
    <label class="list-group-item flex" style="cursor: pointer">
      <div class="flex align-items-center">
        <input
          class="form-check-input me-1 m-0"
          type="radio"
          name="direccion"
          [checked]="direccionSeleccionada === item"
          (change)="seleccionaDireccion(item)"
          aria-label="..."
        />
      </div>
      <div class="flex flex-column" style="margin-left: 30px; color: #0063b9">
        <p class="mb-1">
          {{ item.street }} {{ item.number }}
          {{
            item.departmentHouse && item.departmentHouse != ''
              ? ', ' + item.departmentHouse
              : ''
          }}
        </p>
        <small class="fw-light">{{ item.city }}</small>
      </div>
    </label>
    }
  </div>

  <div class="mt-3">
    <div class="text-center">
      <a
        class="manageAddresses-link fw-semibold"
        (click)="manageAddresses($event)"
      >
        Administrar Direcciones
      </a>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    name="Cerrar"
    class="btn btn-link text-red-500 me-2"
    (click)="ModalRef.hide()"
  >
    Cancelar
  </button>
  <button name="Guardar" class="btn btn-secondary" (click)="guardar()">
    Guardar cambios
  </button>
</div>
